import { render, staticRenderFns } from "./TimelinePage.vue?vue&type=template&id=3c2bb0f2&scoped=true"
import script from "./TimelinePage.vue?vue&type=script&lang=ts"
export * from "./TimelinePage.vue?vue&type=script&lang=ts"
import style0 from "./TimelinePage.vue?vue&type=style&index=0&id=3c2bb0f2&lang=scss&scoped=true"
import style1 from "./TimelinePage.vue?vue&type=style&index=1&id=3c2bb0f2&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2bb0f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c2bb0f2')) {
      api.createRecord('3c2bb0f2', component.options)
    } else {
      api.reload('3c2bb0f2', component.options)
    }
    module.hot.accept("./TimelinePage.vue?vue&type=template&id=3c2bb0f2&scoped=true", function () {
      api.rerender('3c2bb0f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/TimelinePage.vue"
export default component.exports